<template>
  <v-row
    ><v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="50"
        must-sort
        class="elevation-1"
				@click:row="userSelected"
      >
        <template v-slot:item.lastLogin="{ item }">
          {{ formatDateTime(item.lastLogin) }}
        </template>
      </v-data-table>
    </v-col></v-row
  >
</template>

<script>
import dateFunctions from "@/functions/dateFunctions";

export default {
  props: ["users"],
  methods: {
		userSelected(user){
			this.$emit('userSelected', user);
		},
    formatDateTime(date) {

      return (date) ? dateFunctions.formatPalmDateTime(date.slice(0, 8), date.slice(8, 14)) : null ;
    },
  },
  data: () => ({
    headers: [
      {
        text: "Email",
        align: "start",
        sortable: true,
        value: "email",
      },
      { text: "First Name", value: "forename" },
      { text: "Last Name", value: "surname" },
      { text: "Last Login", value: "lastLogin" },
    ],
  }),
};
</script>
